import React from "react";
import { Button, Modal } from "react-bootstrap";
import ActionButton from "../button/ActionButton";
import WhiteGreenButton from "../button/whiteGreenButton";
import imageLogo from "../../../media/images/logo.png"
const MessageAlertModal = ({
  text,
onClose,
  modalStatus,


}) => {
  return (
    <Modal className="fade "    centered show={modalStatus}  style={{}}>
           <div className="d-flex" style={{justifyContent:'flex-end',padding:'5px'}}>
           <Button
            variant=""
            className="btn-close btn-close-password"
            onClick={onClose}
            ></Button>
           </div>
      <div
        className="d-flex align-items-center justify-content-center"
    
        style={{ padding: "30px", flexDirection: "column" }}>
        
            <img src={imageLogo} style={{width:"100px"}} className="mb-4"/>
        <div
          className="fs-5"
          style={{
            fontWeight: "600",
            textAlign: "center",
            padding: "20px",
          }}>
          {text}
        </div>

      
      </div>
    </Modal>
  );
};

export default MessageAlertModal;
